import {memo} from 'react';

import {useTheme} from '@mui/material';
import Box from '@mui/material/Box';
import {bool} from 'prop-types';
import {useNavigate} from 'react-router-dom';

import {APP_ROUTES} from '../../../const';
import useMainSidebar from '../../../hooks/providers/useMainSidebar';
import useReport from '../../../hooks/providers/useReport';
import {reportShape} from '../../../proptypes-shapes';
import {getIconComponent, makeHumanFriendlyUrl} from '../../../utils';
import ActiveSidebarElementIndicator from '../ActiveSidebarElementIndicator/ActiveSidebarElementIndicator';
import SidebarCard from '../SidebarCard/SidebarCard';

const SingleReportCard = ({report, isDisplayedInMoreReportsPopper = false}) => {
  const {selectedReport} = useReport();
  const theme = useTheme();
  const navigate = useNavigate();
  const {setIsReportAndModulesMobileDrawerOpen, closeAllSidebarRelatedPoppers} = useMainSidebar();

  const isReportSelected = report.report_id === selectedReport?.config?.id;

  const handleClick = () => {
    if (isReportSelected) return;

    const url = makeHumanFriendlyUrl(APP_ROUTES.report(report.report_name));
    navigate(url, {
      state: {
        reportId: report.report_id
      }
    });
    closeAllSidebarRelatedPoppers();
    setIsReportAndModulesMobileDrawerOpen(false);
  };

  const labelMaxLength = 18;
  const fullLabel = report.report_name;
  const sanitizedLabel = fullLabel.replace(/_/g, ' ');

  const isLabelEllipsed = sanitizedLabel.length > labelMaxLength;
  const label = isLabelEllipsed ? `${sanitizedLabel.slice(0, labelMaxLength - 3)}...` : sanitizedLabel;
  const IconComponent = getIconComponent(report.icon);
  const iconColor = isReportSelected ? theme.palette.primary.main : '#6F6F6F';

  if (!report.is_visible && !isDisplayedInMoreReportsPopper) {
    return null;
  }

  return (
    <Box width="100%" display="flex" mb={report.is_visible ? 0.5 : 0}>
      <ActiveSidebarElementIndicator isVisible={isReportSelected} />

      <Box ml={-0.5} display="flex" justifyContent="center" width="100%">
        <SidebarCard
          itemIsDisplayedInSidebar={!isDisplayedInMoreReportsPopper}
          hasBetaRibbon={report.is_beta}
          label={label}
          icon={<IconComponent sx={{color: iconColor}} />}
          tooltip={isLabelEllipsed ? sanitizedLabel : ''}
          selected={isReportSelected}
          disabled={false}
          onClick={handleClick}
        />
      </Box>
    </Box>
  );
};

SingleReportCard.propTypes = {
  report: reportShape.isRequired,
  isDisplayedInMoreReportsPopper: bool.isRequired
};

export default memo(SingleReportCard);
